import { Atom, state } from ":mods";
import { SinlgeNote } from "./single-note";
import { For, Show } from "solid-js";
const single_note = {
  id: 0,
  title: "My Note 1",
  description:
    "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minima officiis velit voluptatem repellat qui expedita dolores corporis labore! Tenetur at non obcaecati excepturi sed voluptate, quidem rerum quas voluptas veniam!",
};
export function ShowSideNotes() {
  const $active_note = state.create<typeof single_note>(undefined);
  const notes: (typeof single_note)[] = [];
  for (let i = 0; i < 3; i++) {
    const new_note = { ...single_note };
    new_note.id = i;
    new_note.title = `My Note ${i}`;
    notes.push(new_note);
  }

  return (
    <Atom.Foldable.Accordion
      title="My Notes"
      arrowMode="end"
      class="border-none mt-5"
      groupClass="flex flex-row space-x-2"
      iconClass="icon-local-top-nav:down-arrow-dark"
      iconRotationClass={{
        idle: "rotate-90",
        rotated: "",
      }}
    >
      <main class="flex flex-col w-full h-50% ">
        <Show
          when={!$active_note.value}
          fallback={
            <div>
              <button class="form-btn text#p underline">back</button>
              <div class=""></div>
              <div class="flex flex-row children:(w-50px h-px)">
                <button class="form-btn bg#paper">Cancel</button>
                <button class="form-btn">Save</button>d
              </div>
            </div>
          }
        >
          {/* notes scrollable area */}
          <div class="overflow-auto">
            <For each={notes}>
              {(item, index) => {
                return (
                  <SinlgeNote
                    elements={item}
                    events={{
                      onEdit: () => {
                        console.log("edit");
                      },
                      onDelete: () => {
                        console.log("delete");
                      },
                    }}
                  />
                );
              }}
            </For>
          </div>
          <button
            class="form-btn"
            onclick={() => {
              $active_note.set({
                id: -1,
                title: "My Note Title",
                description: undefined,
              });
            }}
          >
            Add Note
          </button>
        </Show>
      </main>
    </Atom.Foldable.Accordion>
  );
}
